import React from "react";
import { compose } from "recompose";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import Paragraph from "../styleguide/Paragraph";
import Heading5 from "../styleguide/Heading5";
import withLocalization from "../hocs/withLocalization";
import { languagesConfig } from "../components/LanguageMenu";
import classnames from "classnames";
import withConnectionStatus from "../hocs/withConnectionStatus";
import { graphql } from "react-apollo";
import entryScreenQuery from "../queries/entryScreen";
import withErrorState from "../hocs/withErrorState";
import withLoadingState from "../hocs/withLoadingState";
import withFlattenedTranslations from "../hocs/withFlattenedTranslations";

const styles = (theme) => ({
    root: {
        backgroundColor: "#fff",
    },
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        alignItems: "center",
        marginTop: 40,
        marginBottom: 40,
    },
    copyrightStyle: {
        flex: 1,
        marginTop: 25,
        fontSize: 15,
        fontFamily: "MAN-light, Arial, sans-serif",
    },
    list: {
        listStyle: "none",
        padding: 0,
    },
    listHeading: {
        color: "#303C49",
        fontSize: 15,
        marginBottom: 16,
        textDecoration: "none",
    },
    listItem: {
        marginBottom: 24,
    },
    listLink: {
        color: "#303C49",
        fontSize: 15,
        textDecoration: "none",
        cursor: "pointer",

        "&:hover, &:focus": {
            color: "#e40045",
        },
    },
    divider: {
        width: "100%",
        border: "1px solid #D6D8DB",
        margin: "20px 0",
    },
    active: {
        fontWeight: "bold",
        fontFamily: "Arial, sans-serif",
    },
});

const Footer = ({
    classes: { root, list, listLink, listItem, listHeading, divider, containerStyle, copyrightStyle, active },
    language,
    setLanguage,
    generalTranslations,
    isLoggedIn,
    entryScreenItems,
}) => {
    const lionsCity = entryScreenItems.find((item) => item.key === "lionscity");

    return (
        <div className={root}>
            <div className={containerStyle}>
                {isLoggedIn && (
                    <React.Fragment>
                        <Grid container={16}>
                            {lionsCity && (
                                <Grid xs={3}>
                                    <Heading5 className={listHeading}>{lionsCity.title}</Heading5>
                                    <ul className={list}>
                                        {lionsCity.entryScreenSubItems.map((subItem, index) => (
                                            <li key={index} className={listItem}>
                                                <Link to={subItem.linkUrl} className={listLink}>
                                                    {subItem.title}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </Grid>
                            )}
                            <Grid xs={3}>
                                {entryScreenItems
                                    .filter((item) => item.key !== "lionscity")
                                    .map((item) => (
                                        <Heading5
                                            key={item.key}
                                            className={listHeading}
                                            component={Link}
                                            to={item.linkUrl}
                                        >
                                            {item.title}
                                        </Heading5>
                                    ))}
                            </Grid>
                        </Grid>
                        <div className={divider} />
                    </React.Fragment>
                )}
                <Grid container spacing={16}>
                    <Grid item xs={3}>
                        {Object.keys(languagesConfig).map((lang) => (
                            <a
                                key={lang}
                                onClick={() => setLanguage(lang)}
                                className={classnames(listLink, { [active]: language === lang })}
                                style={{ marginRight: 20 }}
                            >
                                {lang}
                            </a>
                        ))}
                    </Grid>
                    <Grid item xs={3}>
                        <a className={listLink} href="mailto:info@mybus.man.eu">
                            {generalTranslations("feedback")}
                        </a>
                    </Grid>
                    <Grid item xs={3}>
                        <Link to="/disclaimer" className={listLink}>
                            Disclaimer
                        </Link>
                    </Grid>
                </Grid>
                <Paragraph condensed className={copyrightStyle}>
                    &copy; MAN {new Date().getFullYear()}
                </Paragraph>
            </div>
        </div>
    );
};

export default compose(
    withGeneralTranslations,
    withConnectionStatus,
    withLocalization,
    graphql(entryScreenQuery, {
        options: ({ language, fetchPolicy, stage }) => ({
            variables: {
                lang: language.toLowerCase(),
                stage,
            },
            fetchPolicy,
        }),
    }),
    withErrorState,
    withLoadingState("entryScreenItems"),
    withFlattenedTranslations("entryScreenItems"),
    withStyles(styles)
)(Footer);



// WEBPACK FOOTER //
// ./src/layouts/Footer.js